<div #modal class="modal" [ngStyle]="{'display': showModal ? 'flex' : 'none'}">
  <div #modalBody class="modal__body" [ngClass]="{
      'modal__body--lg' : size === 'lg',
      'modal__body--md' : size === 'md',
      'modal__body--sm' : size === 'sm',
      'modal__body--fixed-height' : fixedHeight}">
    <div class="modal__icon modal__icon--danger" *ngIf="danger">
      <img id="modal.exclamation" src="assets/icons/exclamation.svg" alt="Exclamation">
    </div>
    <div class="modal__wrapper">
      <div class="modal__header">
        {{header}}
        <span class="modal__caption" *ngIf="subHeader">{{subHeader}}</span>
        <span class="modal__close" id="modal.close" cy="modal-close" (click)="closeModal()">&times;</span>
      </div>
      <div class="modal__content" [ngClass]="{'modal__content--with-header': header}">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
